(function(){
  'use strict';
  var NV = window.NV || {};
  var routes = NV.routes || {cart_add_url:'/cart/add',cart_change_url:'/cart/change',cart_url:'/cart'};
  var $ = function(s,r){return (r||document).querySelector(s)};
  var $$ = function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var DRAWER_SECTION = 'nv-cart-drawer';

  function toast(msg){
    var t = $('#nvToast'); if(!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function(){t.classList.remove('show')},3200);
  }
  function money(cents){
    try{ return new Intl.NumberFormat(NV.locale||'en-AU',{style:'currency',currency:NV.currency||'AUD'}).format(cents/100); }
    catch(e){ return '$'+(cents/100).toFixed(2); }
  }
  function lock(on){document.body.classList.toggle('nv-lock',!!on)}

  /* ---------- mobile nav ---------- */
  var mnav = null;
  function setNav(open){
    mnav = $('[data-mnav]');
    if(!mnav) return;
    mnav.classList.toggle('open',open); lock(open);
    $$('[data-mnav-open]').forEach(function(b){b.setAttribute('aria-expanded',open)});
    if(open){var c=$('[data-mnav-close]',mnav); c&&c.focus();}
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-mnav-open]')){e.preventDefault();setNav(true)}
    else if(e.target.closest('[data-mnav-close]')||e.target.matches('[data-mnav]')){setNav(false)}
    else if(mnav && mnav.classList.contains('open') && e.target.closest('[data-mnav] a')){setNav(false)}
  });

  /* ---------- desktop dropdowns close on outside click ---------- */
  document.addEventListener('click',function(e){
    $$('.nav details[open]').forEach(function(d){ if(!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------- cart drawer ---------- */
  function drawer(){return $('[data-drawer]')}
  function openDrawer(){var d=drawer(); if(!d) return false; d.classList.add('open'); d.setAttribute('aria-hidden','false'); lock(true); var c=$('[data-drawer-close]',d); c&&c.focus(); return true}
  function closeDrawer(){var d=drawer(); if(!d) return; d.classList.remove('open'); d.setAttribute('aria-hidden','true'); lock(false)}
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-cart-open]');
    if(o && NV.cartType==='drawer' && drawer()){e.preventDefault();openDrawer();return}
    if(e.target.closest('[data-drawer-close]')){e.preventDefault();closeDrawer()}
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){closeDrawer();setNav(false)} });

  function setCount(n){ $$('[data-cart-count]').forEach(function(el){el.textContent=n;el.setAttribute('data-count',n)}); $$('[data-cart-label]').forEach(function(el){el.setAttribute('aria-label','Cart, '+n+(n===1?' item':' items'))}); }
  function renderDrawer(html){
    if(!html) return;
    var doc = new DOMParser().parseFromString(html,'text/html');
    var fresh = $('[data-drawer-inner]',doc), cur = $('[data-drawer-inner]');
    if(fresh && cur){ cur.innerHTML = fresh.innerHTML; }
    var cnt = $('[data-drawer-count]',doc);
    if(cnt) setCount(parseInt(cnt.getAttribute('data-drawer-count'),10)||0);
  }
  function refreshCart(){
    return fetch(routes.cart_url+'?section_id='+DRAWER_SECTION).then(function(r){return r.text()}).then(renderDrawer).catch(function(){});
  }

  /* ---------- add to cart ---------- */
  document.addEventListener('submit',function(e){
    var form = e.target.closest('form[data-ajax-cart]');
    if(!form) return;
    e.preventDefault();
    var btn = $('[type="submit"]',form), msg = $('[data-form-msg]',form);
    if(msg){msg.textContent='';msg.className='form-msg'}
    btn && btn.classList.add('is-loading');
    var fd = new FormData(form);
    if(NV.cartType==='drawer') fd.append('sections',DRAWER_SECTION);
    fetch(routes.cart_add_url+'.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok){ var m=res.j.description||res.j.message||'This item could not be added.'; if(msg){msg.textContent=m;msg.className='form-msg msg msg--err'} else toast(m); return; }
        document.dispatchEvent(new CustomEvent('nv:cart-added',{detail:res.j}));
        if(NV.cartType==='page'){ window.location.href = routes.cart_url; return; }
        if(res.j.sections && res.j.sections[DRAWER_SECTION]) renderDrawer(res.j.sections[DRAWER_SECTION]); else refreshCart();
        if(!openDrawer()) toast((res.j.product_title||'Item')+' added to cart');
      })
      .catch(function(){ form.removeAttribute('data-ajax-cart'); form.submit(); })
      .then(function(){ btn && btn.classList.remove('is-loading'); });
  });

  /* ---------- drawer line changes ---------- */
  function changeLine(line,qty,el){
    var row = el && el.closest('.line'); row && row.classList.add('is-busy');
    fetch(routes.cart_change_url+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty,sections:[DRAWER_SECTION],sections_url:window.location.pathname})})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok){toast(res.j.description||'Could not update the cart');row&&row.classList.remove('is-busy');return}
        if(res.j.sections) renderDrawer(res.j.sections[DRAWER_SECTION]); else refreshCart();
        if(res.j.item_count!==undefined) setCount(res.j.item_count);
      }).catch(function(){row&&row.classList.remove('is-busy')});
  }
  document.addEventListener('click',function(e){
    var b = e.target.closest('[data-line-change]');
    if(b && b.closest('[data-drawer]')){ e.preventDefault(); changeLine(parseInt(b.getAttribute('data-line'),10),parseInt(b.getAttribute('data-qty'),10),b); }
  });
  document.addEventListener('change',function(e){
    var i = e.target.closest('[data-line-input]');
    if(i && i.closest('[data-drawer]')){ changeLine(parseInt(i.getAttribute('data-line'),10),Math.max(0,parseInt(i.value,10)||0),i); }
    var p = e.target.closest('[data-cart-page] [data-autosubmit]');
    if(p){ p.form && p.form.submit(); }
  });

  /* ---------- quantity steppers (product forms, cart page) ---------- */
  document.addEventListener('click',function(e){
    var s = e.target.closest('[data-qty-step]');
    if(!s || s.closest('[data-drawer]')) return;
    e.preventDefault();
    var input = s.parentNode.querySelector('input'); if(!input) return;
    var v = (parseInt(input.value,10)||0) + parseInt(s.getAttribute('data-qty-step'),10);
    input.value = Math.max(parseInt(input.min||'0',10),v);
    input.dispatchEvent(new Event('change',{bubbles:true}));
  });

  /* ---------- variant picker + gallery ---------- */
  function initProduct(root){
    if(root._nv) return; root._nv = true;
    var dataEl = $('script[data-variants]',root);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = $('input[name="id"]',root);
    function selected(){
      return $$('[data-option-group]',root).map(function(g){ var c=$('input:checked',g); return c?c.value:null; });
    }
    function update(){
      var sel = selected();
      var v = variants.find(function(x){ return x.options.every(function(o,i){return o===sel[i]}); });
      var atc = $('[data-atc]',root), price=$('[data-price]',root), cmp=$('[data-compare]',root), label=$$('[data-option-value]',root);
      sel.forEach(function(val,i){ var l=$('[data-option-value="'+i+'"]',root); if(l) l.textContent=val; });
      // availability hint per pill
      $$('[data-option-group]',root).forEach(function(g,gi){
        $$('input',g).forEach(function(inp){
          var test = sel.slice(); test[gi]=inp.value;
          var ok = variants.some(function(x){return x.available && x.options.every(function(o,i){return o===test[i]})});
          inp.closest('.pill').classList.toggle('is-unavailable',!ok);
        });
      });
      if(!v){ if(atc){atc.disabled=true;atc.textContent=atc.getAttribute('data-unavailable')||'Unavailable'} return; }
      if(idInput) idInput.value = v.id;
      if(price) price.textContent = v.price_fmt || money(v.price);
      if(cmp){ if(v.compare_at_price && v.compare_at_price>v.price){cmp.textContent=v.compare_fmt||money(v.compare_at_price);cmp.hidden=false}else{cmp.hidden=true} }
      if(atc){ atc.disabled=!v.available; atc.textContent = v.available ? (atc.getAttribute('data-add')||'Add to cart') : (atc.getAttribute('data-soldout')||'Sold out'); }
      if(v.featured_media) showMedia(root,String(v.featured_media));
      if(root.hasAttribute('data-update-url') && window.history.replaceState){
        var u = new URL(window.location.href); u.searchParams.set('variant',v.id); window.history.replaceState({},'',u.toString());
      }
      root.dispatchEvent(new CustomEvent('nv:variant',{detail:v,bubbles:true}));
    }
    root.addEventListener('change',function(e){ if(e.target.closest('[data-option-group]')) update(); });
    root.addEventListener('click',function(e){
      var t=e.target.closest('[data-thumb]'); if(t){ e.preventDefault(); showMedia(root,t.getAttribute('data-thumb')); }
    });
    if(variants.length) update();
  }
  function showMedia(root,id){
    var slides=$$('[data-slide]',root); if(!slides.length) return;
    var hit=slides.some(function(s){return s.getAttribute('data-slide')===id});
    if(!hit) return;
    slides.forEach(function(s){ s.classList.toggle('is-active',s.getAttribute('data-slide')===id); });
    $$('[data-thumb]',root).forEach(function(t){ t.setAttribute('aria-current',t.getAttribute('data-thumb')===id?'true':'false'); });
  }

  /* ---------- camera toggle ---------- */
  function initCam(root){
    if(root._nv) return; root._nv=true;
    var svg=$('svg[data-cam-svg]',root), text=$('[data-cam-text]',root);
    $$('[data-cam-btn]',root).forEach(function(b){
      b.addEventListener('click',function(){
        var pro = b.getAttribute('data-cam-btn')==='pro';
        $$('[data-cam-btn]',root).forEach(function(x){x.setAttribute('aria-pressed',x===b)});
        if(svg) svg.classList.toggle('is-pro',pro);
        if(text) text.textContent = b.getAttribute('data-copy')||'';
      });
    });
  }

  /* ---------- notify / tag forms ---------- */
  document.addEventListener('submit',function(e){
    var f = e.target.closest('form[data-notify-form]'); if(!f) return;
    var root = f.closest('[data-notify-root]')||f;
    var tags = [f.getAttribute('data-base-tags')||'notify'];
    $$('input[data-notify-tag]:checked',root).forEach(function(c){tags.push(c.getAttribute('data-notify-tag'))});
    var hidden = $('input[name="contact[tags]"]',f); if(hidden) hidden.value = tags.join(',');
  },true);

  /* ---------- sort select ---------- */
  document.addEventListener('change',function(e){
    var s = e.target.closest('[data-sort]'); if(!s) return;
    var u = new URL(window.location.href); u.searchParams.set('sort_by',s.value); u.searchParams.delete('page'); window.location.href=u.toString();
  });

  /* ---------- product recommendations ---------- */
  function initRecs(root){
    if(root._nv) return; root._nv=true;
    var url=root.getAttribute('data-recs-url'); if(!url) return;
    fetch(url).then(function(r){return r.text()}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html'); var inner=$('[data-recs]',doc);
      if(inner && inner.innerHTML.trim()) root.innerHTML=inner.innerHTML; else root.closest('.shopify-section') && (root.closest('.sec').hidden=true);
    }).catch(function(){});
  }

  function init(scope){
    $$('[data-product]',scope).forEach(initProduct);
    $$('[data-cam]',scope).forEach(initCam);
    $$('[data-recs-url]',scope).forEach(initRecs);
  }
  document.addEventListener('DOMContentLoaded',function(){ init(document); });
  if(document.readyState!=='loading') init(document);
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
  document.addEventListener('shopify:section:select',function(e){ if(e.target.querySelector('[data-drawer]')) openDrawer(); });
  document.addEventListener('shopify:section:deselect',function(e){ if(e.target.querySelector('[data-drawer]')) closeDrawer(); });
  window.NV = Object.assign(NV,{toast:toast,openCart:openDrawer,refreshCart:refreshCart});
})();
